export const REPORT_TYPES = [
	{ name: 'Final Report', default: true },
	{ name: 'Run Tally', default: true },
	{ name: 'Exceptions', default: false, multiple: true },
	{ name: 'DOC', default: true },
	{ name: 'CurrentSource', default: true },
	{ name: 'Test Stations', default: true },
	{ name: 'Skipped Areas', default: true },
	{ name: 'Mismarked Pipeline Locations', default: true },
	{ name: 'Malfunctioned Test Leads', default: true },
	{ name: 'AGM Report', default: false }
];
